import React from "react";
import Navbar from "../components/Navbar/Navbar";
import { supplierMenu } from "../data/supplierMenu";

const SupplierLayout = ({ children, handleShow }) => {
  return (
    <>
      <Navbar menuList={supplierMenu} handleShow={handleShow} />
      {children}
    </>
  );
};

export default SupplierLayout;
